import Logo from "../../../vendor/swan.png";
import "./ProductInfo.css";

interface ProductBrandCardProps {
  title: string;
  description: string;
}

export default function ProductBrandCard({
  title,
  description,
}: ProductBrandCardProps) {
  return (
    <section className="product-brand-card">
      <div className="product-brand">
        <img src={Logo} alt="WhiteSwan logo" />
        <div>
          <span className="product-brand-name">WHITESWAN</span>
          <span className="product-brand-tagline">Identity Security</span>
        </div>
      </div>
      <div className="product-brand-copy">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </section>
  );
}
